<mat-accordion>
  @for (license of licenses; track license) {
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ license.name }} {{ license.version ? '(' + license.version + ')' : '' }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="license-details">
        @if (license.licenses) {
          <span>Released under {{ license.licenses }} license </span>
        }
        @if (license.publisher) {
          <span>by {{ license.publisher }}
            @if (license.email) {
              <span>({{ license.email }})</span>
            }
          </span>
        }
        @if (license.repository) {
          <p>
            <strong>Repository:</strong>&nbsp;<a [href]="license.repository" target="_blank">{{ license.repository }}</a>
          </p>
        }
        @if (license.licenseText) {
          <div>
            <div class="license-notice">
              <pre class="license-text">{{ license.licenseText }}</pre>
            </div>
          </div>
        }
      </div>
    </mat-expansion-panel>
  }
</mat-accordion>
